<template>
  <div>
    <div v-if="reservationMode">
      <docomo-marker />
      <my-spot-marker />
    </div>
    <div v-else>
      <destination-marker />
      <spot-marker />
      <google-place-marker />
      <location-marker />
      <my-spot-marker />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SpotMarker from './SpotMarker'
import DestinationMarker from './DestinationMarker'
import GooglePlaceMarker from './GooglePlaceMarker'
import LocationMarker from './LocationMarker'
import DocomoMarker from './DocomoMarker'
import MySpotMarker from './MySpotMarker'


export default {
  components: {
    SpotMarker,
    DestinationMarker,
    GooglePlaceMarker,
    LocationMarker,
    DocomoMarker,
    MySpotMarker
  },
  methods: {
    onMarkerSelected: function (place) {
      this.$emit('markerSelected', place)
    }
  },
  computed: {
    ...mapGetters({
      reservationMode: 'reservation/getMode'
    })
  }
}
</script>
